import { Box, makeStyles, Tooltip, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";

import useAllStat from "../../../../hooks/useAllStat";
import useStatTotalSubs from "../../../../hooks/useStatTotalSubs";
import { abbreviateNumber } from "../../../../utils";
import useTierInfo from "../../../../hooks/useTiers";
import { Loading } from "react-admin";

const useStyles = makeStyles((theme) => ({
  card: {
    //height: CHART_HEIGHT + 16,
    width: 580,
    borderRadius: 8,
    boxShadow: "0px 10px 0px -7px rgba(0,0,0,0)",
    height: 179,

    backgroundColor: "white",
    padding: "23px 17px 10px 30px",
    boxSizing: "border-box",
    overflowY: "hidden",
    overflowX: "hidden",
  },
  textHeaderStyle: {
    fontSize: "18px",
    fontWeight: "bold",
    color: theme.blue,
  },
  revenueColor: {
    color: theme.darkGray,
  },
  memberColor: {
    color: theme.orange,
  },
  revenueBarColor: {
    backgroundColor: theme.darkGray,
  },
  memberBarColor: {
    backgroundColor: theme.orange,
  },
}));

const PERIOD_TYPE = "All";
const FROM_DATE = "2020-01-01";
const TO_DATE = "2100-12-31";

const TierTriangleChart = () => {
  const classes = useStyles();
  const { getMembers } = useAllStat();
  const { totalSubs, loading, error } = useStatTotalSubs(
    PERIOD_TYPE,
    FROM_DATE,
    TO_DATE
  );

  // const {
  //   statRevenue,
  //   loading: loadingRev,
  //   error: errorRev,
  // } = useStatRevenue("All", "2020-01-01", "2100-12-31");
  const [dataList, setDataList] = useState();

  const { tiers, loading: tierLoading, error: tierError } = useTierInfo();

  useEffect(() => {
    async function createData() {
      if (totalSubs && tiers) {
        const [members] = await getMembers({
          fromDate: FROM_DATE,
          toDate: TO_DATE,
          periodType: PERIOD_TYPE,
        });

        const tierNames = tiers?.map((t) => t.name);
        if (tierNames.length === 0) {
          return setDataList({
            labels: ["No data"],
            dataMembers: [0],
            dataRev: [0],
          });
        }

        const revs = Array(tierNames.length).fill(0);

        if (members) {
          members.forEach((member) => {
            tierNames.forEach((tierName, index) => {
              if (tierName === member.tier) {
                console.log(
                  member.firstname +
                    ":" +
                    member.tier +
                    ":" +
                    member?.payment?.total_revenue ?? 0
                );
                revs[index] += member?.payment?.total_revenue ?? 0;
              }
            });
          });
        } else {
          return setDataList({
            labels: ["No data"],
            dataMembers: [0],
            dataRev: [0],
          });
        }
        console.log(tierNames);
        console.log(revs);
        return setDataList({
          labels: tierNames,
          dataMembers: tierNames.map((tier) => {
            if (totalSubs && totalSubs?.length > 0) {
              const result = Object.values(totalSubs[0].segment?.tier).find(
                (value) => value.name === tier
              );
              if (result) {
                return result.value;
              } else return 0;
            } else {
              return 0;
            }
          }),
          dataRev: revs,
        });
      }
    }
    createData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalSubs, tiers]);
  if (loading || tierLoading || !dataList)
    return (
      <Box className={classes.card}>
        <Loading />
      </Box>
    );

  if (error || tierError) return <Box>Error</Box>;

  return (
    <Box className={classes.card}>
      <ChampSidebySidePyramid
        title={"Tier"}
        dataMembers={dataList.dataMembers}
        dataRev={dataList.dataRev}
        labels={dataList.labels}
      />
    </Box>
  );
};

const roundNext = (value) => {
  const wholeValue = Math.ceil(value);
  const numberOfZero = wholeValue.toString().length - 2;
  if (numberOfZero <= 0) return value;
  const tenth = Math.pow(10, numberOfZero);

  return Math.ceil(value / tenth) * tenth;
};

const ChampSidebySidePyramid = ({ title, dataMembers, dataRev, labels }) => {
  const width = 210;
  const [boxLengths, setBoxLengths] = useState();
  const classes = useStyles();
  const [maxScale, setMaxScale] = useState();
  useEffect(() => {
    const max = roundNext(Math.max(...dataMembers));

    const maxRev = roundNext(Math.max(...dataRev));
    setBoxLengths(
      dataMembers.map((data, index) => [
        (data * width) / max,
        (dataRev[index] * width) / maxRev,
      ])
    );

    const memberScales = [];
    const revScales = [];
    memberScales.push(abbreviateNumber(max));
    for (let i = 1; i < 4; i++)
      memberScales.push(abbreviateNumber(max - (max * i) / 4));
    for (let i = 4; i > 0; i--)
      revScales.push(abbreviateNumber(maxRev - (maxRev * i) / 4));
    revScales.push(abbreviateNumber(maxRev));

    setMaxScale({
      member: memberScales.map((m) => {
        const display = String(m);
        if (display.length === 1) return " " + m + " ";
        if (display.length === 2) return m + " ";
        return m;
      }),
      rev: revScales.map((m) => {
        const display = String(m);
        if (display.length === 1) return " " + m + " ";
        if (display.length === 2) return m + " ";
        return display;
      }),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: "auto 118px 118px",
          width: "100%",
        }}
      >
        <Typography className={classes.textHeaderStyle}>{title}</Typography>
        <Box
          style={{
            display: "grid",
            gap: 5,
            gridTemplateColumns: "18px 100px",
            alignItems: "center",
          }}
        >
          <Box
            style={{ width: 12, height: 12, borderRadius: 6 }}
            className={classes.memberBarColor}
          ></Box>
          <Typography style={{ fontSize: 10 }}>Member (People)</Typography>
        </Box>
        <Box
          style={{
            display: "grid",
            gap: 5,
            gridTemplateColumns: "18px 100px",
            alignItems: "center",
          }}
        >
          <Box
            style={{ width: 12, height: 12, borderRadius: 6 }}
            className={classes.revenueBarColor}
          ></Box>
          <Typography style={{ fontSize: 10 }}>Revenue (THB)</Typography>
        </Box>
      </Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: 500,
          backgroundColor: "transparent",
          borderRadius: 12,
          padding: 0,
          marginTop: 0,
        }}
      >
        <Box
          style={{
            width: "100%",
            position: "relative",
          }}
        >
          {boxLengths?.map(([lengthA, lengthB], index) => {
            return (
              <Box
                style={{
                  display: "grid",
                  gridTemplateColumns: "60px 230px  230px",
                  gap: 0,
                  width: "100%",
                  position: "relative",
                }}
              >
                <Box>
                  <Typography
                    align="left"
                    variant="body1"
                    marginTop={1.5}
                    style={{ fontSize: 14, lineHeight: 1.2 }}
                  >
                    {labels[index]}
                  </Typography>
                </Box>
                <Box style={{ position: "relative" }}>
                  <Box
                    style={{
                      display: "grid",
                      gridTemplateColumns: " repeat(4, minmax(0, 1fr))",
                      height: "100%",
                    }}
                  >
                    <GridBox />
                    <GridBox />
                    <GridBox />
                    <GridBox />
                  </Box>
                  <Tooltip title={dataMembers[index]?.toLocaleString()}>
                    <Box
                      style={{
                        position: "absolute",
                        right: 3,
                        bottom: 3,

                        width: lengthA,
                        height: 11,
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "2px 0 0 2px",
                      }}
                      className={classes.memberBarColor}
                    />
                  </Tooltip>
                </Box>

                <Box style={{ position: "relative" }}>
                  <Box
                    style={{
                      display: "grid",
                      gridTemplateColumns: " repeat(4, minmax(0, 1fr))",
                      height: "100%",
                    }}
                  >
                    <GridBox />
                    <GridBox />
                    <GridBox />
                    <GridBox />
                  </Box>
                  <Tooltip title={dataRev[index]?.toLocaleString()}>
                    <Box
                      style={{
                        width: lengthB,
                        height: 11,
                        position: "absolute",
                        left: 4,
                        bottom: 3,
                        borderRadius: "0 2px 2px 0",
                      }}
                      className={classes.revenueBarColor}
                    />
                  </Tooltip>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: "60px 500px",
          gap: 0,
          width: "100%",
        }}
      >
        <Box></Box>
        <Box
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
          }}
        >
          {maxScale?.member?.map((scale) => {
            return (
              <Typography
                className={classes.memberColor}
                color="primary"
                align="center"
                style={{ marginLeft: -53, fontSize: 14 }}
              >
                {scale}
              </Typography>
            );
          })}
          {maxScale?.rev?.map((scale) => {
            return (
              <Typography
                className={classes.revenueColor}
                align="center"
                style={{ marginLeft: -40, fontSize: 14 }}
              >
                {scale}
              </Typography>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

const GridBox = () => {
  return (
    <Box
      style={{
        borderTop: "1px solid #ebebeb",
        borderLeft: "1px solid #ebebeb",
        height: "100%",
      }}
    />
  );
};

export default TierTriangleChart;
